import Box from '@material-ui/core/Box/Box';
import React, { FC } from 'react';

import Fisgar from '../components/fisgar';

const App: FC = () => (
  <Box minHeight="100vh">
    <Fisgar />
  </Box>
);

export default App;
